/**
 * ThemeContext.js — 테마 관리 (사주팔자AI는 다크 전용 고정)
 *
 * saju2you-theme.css(Astra 디자인)는 전 영역이 다크 전용으로 구성돼 있고,
 * `html[data-theme='light']`에도 본문/표 텍스트를 밝은 크림색으로 !important 강제한다.
 * 반면 라이트 모드 배경은 일부만 밝게 남아, 라이트 모드(기기 시스템 설정) 사용자에게는
 * "밝은 배경 위 밝은 글씨 = 안 보임"(드래그해야 보이는) 가독성 버그가 발생한다.
 *
 * 정식 라이트 테마가 완성되기 전까지 시스템 설정과 무관하게 'dark'로 고정한다.
 * (앱 디자인 자체가 다크 전용이며, 라이트 토글 UI도 존재하지 않는다.)
 * ※ 자매 포크 saju2you(청명당)는 반대로 '라이트 한지 전용'이라 'light'로 고정한다.
 */
import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

const FORCED_THEME = 'dark';

export function ThemeProvider({ children }) {
  const theme = FORCED_THEME;

  /* Apply data-theme attribute to <html> + 과거 라이트로 저장됐을 수 있는 값 제거 */
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.removeItem('app-theme'); } catch {}
  }, [theme]);

  /* 다크 전용이므로 토글은 no-op (컨텍스트 API는 호환을 위해 유지) */
  const toggleTheme = () => {};
  const isDark = true;

  return (
    <ThemeContext.Provider value={{ theme, isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
